module.exports = __webpack_public_path__ + "img/business-and-finance.9df85be3.png";